import React, { Component } from 'react';
import styled from 'styled-components';

import Layout from '../../components/Layout';
// import ContactsFormBlock from '../../common/ContactsFormBlock';
import Form from '../../common/FormContainer';
import ContactsBlock from '../../components/Contacts';
import Content from '../../common/Content';

import mediaWidth from '../../utils/mediaWidth/mediaWidth';
import Analytics from '../../services/Analytics';

import { getDirectionCheckboxes } from '../../utils/directionsData';
import anchorScroll from '../../utils/anchorScroll';

class Contacts extends Component {
    constructor() {
        super();
        this.scrollTo = this.scrollTo.bind(this);
    }

    componentDidMount() {
        Analytics.pageView('/contacts', 'Contacts Page');
    }

    scrollTo() {
        const { scrollRef } = this.props;
        anchorScroll(scrollRef);
    }

    render() {
        const {
            className,
            handleChangePage,
            scrollRef,
            extractCheckboxes = getDirectionCheckboxes,
        } = this.props;

        return (
            <Root className={className} handleChangePage={handleChangePage}>
                <ContentWrapper>
                    <Wrapper backgroundColor="#F5F5F5">
                        <FormStyled
                            rootRef={scrollRef}
                            checkboxes={extractCheckboxes()}
                            scrollTo={this.scrollTo}
                        />
                    </Wrapper>
                    <Wrapper>
                        <ContactsBlockStyled page />
                    </Wrapper>
                </ContentWrapper>
            </Root>
        );
    }
}

const Root = styled(Layout)`
`;

const Wrapper = styled(Content)`
`;

const ContentWrapper = styled.div`
    display: flex;
    flex-direction: column-reverse;

    padding: 187px 0px 0px 0px;

    ${mediaWidth.m} {
        flex-direction: row;

        padding: 213px 0px 0px 0px;
    }

    ${mediaWidth.xl} {
        max-width: 1440px;
        margin: 0 auto;

        padding: 245px 0px 0px 0px;
    }
`;

const FormStyled = styled(Form)`
    padding-top: 64px;
    padding-bottom: 64px;

    ${mediaWidth.m} {
        padding-top: 0px;
        padding-bottom: 96px;
    }

    ${mediaWidth.xl} {
        width: 405px;
    }
`;


const ContactsBlockStyled = styled(ContactsBlock)`
    margin-bottom: 93px;

    ${mediaWidth.m} {
        margin-bottom: 0px;
    }
`;


export default Contacts;
